import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles.css';
import App from './App';
import { ShopProvider } from './context/ShopContext';

// The live UI is built entirely on Shopify's `s-*` Polaris web components
// (custom elements, no React context), so no Polaris React `AppProvider` is
// needed — dropping it keeps the whole @shopify/polaris React bundle + its CSS
// out of the entry chunk.
createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ShopProvider>
        <App />
      </ShopProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
